import React from 'react';

const BtnWhiteBlackBorderBigSize = (props) => {
  return (
    <div className='btn-white-black-border-container'>
      <button className='btn-white-black-border' onClick={props.onclick}>
        {props.svgImage && <span dangerouslySetInnerHTML={{__html: props.svgImage}} className='btn-white-black-border-image'></span>}
        <span className='btn-white-black-border-text'>{props.text}</span>
      </button>
    </div>
  );
};

export default BtnWhiteBlackBorderBigSize;
